import { Modal } from "react-bootstrap";
import Messages from "./Messages";

export default function OfflineModal(props) {
    
    let message;
    if (props.urlConfig.Type === '' || props.urlConfig.Type == null || props.urlConfig.Type == 'null' || props.urlConfig.Type == 'web') { // Web Ordering
        message = Messages.ErrorStoreClosedWeb;
    } else {
        if (props.urlConfig.Type == 'k7s5k') { // Kiosk
            message = Messages.ErrorStoreClosedTable;
        } else if (props.urlConfig.Type == 'q8r6e') { // QR Code
            message = Messages.ErrorStoreClosedTable;
        } else if (props.urlConfig.Type == 't9b6f') { // Table Number
            message = Messages.ErrorStoreClosedTable;
        } else { // Default
            message = Messages.ErrorStoreClosedTable;
        }
    }

    // Add Catering here when ready *** TO DO

    return (
        <Modal show={props.offlineModal.IsShown} backdrop="static" keyboard={false}>
            <Modal.Body>
                <div className="col-sm-10 offset-sm-1 text-center my-5">
                    <span>{message}</span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex mx-auto">
                    <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleCloseOfflineModal}>
                        Ok
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}